export default "__VITE_ASSET__CFmcQ07w__"